var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-contact-blue.5d1c562a.png","uri@2x": __webpack_public_path__ + "icon-contact-blue.bcf6b92e.png","uri@3x": __webpack_public_path__ + "icon-contact-blue.6c2af260.png",
    width: 20,
    height: 16
});